
import { Component, Vue } from "vue-property-decorator";
import GenericAdvancedTooltip from "../generic-advanced-tooltip/GenericAdvancedTooltip.vue";
import InteractiveConsole from "@/components/interactive-console-draggable/InteractiveConsole.vue";
import { get } from "lodash";
import { Getter } from 'vuex-class';
import { UserPermissions } from "@/store/types";

@Component({
	components: {
    "generic-advanced-tooltip": GenericAdvancedTooltip,
    "interactive-console": InteractiveConsole
	}
})
export default class InteractiveConsoleDraggable extends Vue {
  @Getter("getFeature") getFeature: (featureName: string[]) => boolean;
  @Getter("getPermissions") getPermissions: UserPermissions;
  private isDialogOpen: boolean = false;

  private get canAccessInteractiveConsole(): boolean {
    return this.getFeature(["InteractiveConsole"]) && this.getPermissions.canAccessInteractiveConsole;
  }

  private toggleDialog() {
    this.isDialogOpen = !this.isDialogOpen;
  }
}
